import { Compass, List, Plus } from '@/ui/icons'
import { Button } from '@/ui/components'
import { useTripsSheet } from './contexts/TripsSheetContext'
import { useCreateModal } from '@/contexts/CreateModalContext'

/**
 * Empty state shown in the center area when no trip is selected on /trips.
 */
export function TripsEmptyState() {
  const tripsSheet = useTripsSheet()
  const { openCreateModal } = useCreateModal()

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] w-full max-w-full p-8 bg-earth-50">
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-earth-100 mb-6">
        <Compass className="h-8 w-8 text-earth-400" />
      </div>
      <h2 className="text-xl font-semibold text-earth-900 mb-2">Select a trip</h2>
      <p className="text-earth-500 text-center max-w-sm mb-6">
        Choose a trip from the list to view details, or create a new adventure.
      </p>
      <div className="flex flex-col sm:flex-row items-center gap-3">
        {tripsSheet && (
          <Button
            className="inline-flex md:hidden gap-2 min-h-[44px]"
            onClick={tripsSheet.openTripsSheet}
          >
            <List className="h-4 w-4" />
            Choose a trip
          </Button>
        )}
        <Button
          className="min-h-[44px] inline-flex items-center gap-2"
          onClick={openCreateModal}
        >
          <Plus className="h-4 w-4" />
          Create trip
        </Button>
      </div>
    </div>
  )
}
